import { ComponentProps } from "react";

export type LayoutProps = ComponentProps<"div">;

export const Layout = ({ children, ...props }: LayoutProps) => {
  return (
    <div
      className={
        "flex justify-start items-center flex-col w-full h-full min-h-screen bg-white p-1 md:p-4"
      }
      {...props}
    >
      {children}
    </div>
  );
};
